import type { ButtonProps } from "@mui/material"
import { VisibilityOffOutlined, VisibilityOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

import { Button } from "@/components/common/Button"

interface ToggleInactiveButtonProps {
  showInactive: boolean
  onToggle: () => void
  label: string
  size?: ButtonProps["size"]
  className?: string
  "data-testid"?: string
}

const ToggleInactiveButton: FC<ToggleInactiveButtonProps> = ({
  showInactive,
  onToggle,
  label,
  size,
  className,
  "data-testid": dataTestId,
}) => (
  <Button
    appearance='text'
    size={size}
    className={className}
    startIcon={showInactive ? <VisibilityOffOutlined /> : <VisibilityOutlined />}
    onClick={onToggle}
    data-testid={dataTestId}
  >
    {showInactive ? "Hide" : "Show"} Inactive {label}
  </Button>
)

export default ToggleInactiveButton
